import { Container, Form, Row, Col, Button, Alert, Table, Spinner, Modal } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import axios from 'axios';
import "./list-collection-face.css";
import { TiDelete, TiDocumentAdd  } from "react-icons/ti";

function ListCollectionsFaces({ id }) {

    const [items, setItems]                             = useState([]);
    const [showAlert, setShowAlert]                     = useState(false);
    const [showLoader, setShowLoader]                   = useState(false);
    const [showDelete, setShowDelete]                   = useState(false);
    const [showAdd, setShowAdd]                         = useState(false);
    const [deleteId, setDeleteId]                       = useState(false);
    const [deleteColletion, setDeleteColletion]         = useState(false);
    const [guardando, setGuardando]                     = useState(false);
    const [inputNombre, setInputNombre]                 = useState("");
    const [image, setImage]                             = useState({ preview: '', data: '' })

    const handleCloseDelete     = () => setShowDelete(false);
    const handleCloseAdd        = () => setShowAdd(false);
    const handleDelete          = () => deleteEvento(deleteId);

    const deleteEvento=(id)=>{
                
            let ud = sessionStorage.getItem('userData');
            let userData = JSON.parse(ud);
    
            const instance = axios.create({
                    baseURL: '',
                    timeout: 5000,
                    headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                    });
            
                instance.post('../api/delete-foto/'+deleteColletion, {tag: id})
                .then(response => {
                    if(response.status === 200){
                        setShowDelete(false);
                        setDeleteId("")
                        setDeleteColletion("")
                        getData()
                    }
                })

    }
    
    const getData= async () => {
        
        setShowLoader(true);
        let ud = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
                baseURL: '',
                timeout: 10000,
                headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                });
        

        await instance.get('../api/list-collection/'+id)
        .then(response => {
            //console.log(response.data.Faces);
            setItems(response.data.Faces)
            setShowLoader(false);
        })
    }

    useEffect(()=>{
        getData()
    },[])


    const handleShowDelete = (item_id, item_collection) => {
        setShowDelete(true);
        setDeleteId(item_id)
        setDeleteColletion(item_collection)
    }

    const handleShowAdd = (item_id, item_collection) => {
        setShowAdd(true);
    }

    const handleFileChange = e => {
        const files = e.target.files;
        const file = files[0];
        getBase64(file);
    }

    const onLoad = fileString => {
        setImage(fileString);
      };

    const getBase64 = file => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          onLoad(reader.result);
        };
      };


    const handleSubmit = async (event) => {
        
        event.preventDefault();

        setGuardando(true);

        if( inputNombre && image ){
          
            let ud = sessionStorage.getItem('userData');
            let userData = JSON.parse(ud);
    
            var vuelto = {
                "tag": inputNombre,
                "file": image
            }
          
            await fetch("../api/add-foto/"+id, {
                method: "POST",
                body: JSON.stringify(vuelto),
                headers: {'Content-Type':'application/json','Authorization': 'Bearer '+userData.access_token}
              })
              .then(response => {
                if(response.status === 200)
                    setShowAlert(true);
                    setImage("")
                    setInputNombre("");
                    setGuardando(false);
                    setShowAdd(false)
                    getData();
              })
              .catch(function (error) {
                console.log(error);
              });
        
        }
        else{
            alert("Faltan Datos, por favor complete el formulario");
            setGuardando(false);
        }

    };

  return (
        <>
            <Container>

                <Row>
                    <Col md={8}>
                        <h1 className="mt-4">Faces in collection - {id}</h1>
                    </Col>
                    <Col className='text-end'>
                        <TiDocumentAdd className='icono_listado icono_listado_big' onClick={() => handleShowAdd()} />
                    </Col>
                </Row>
                {
                    showLoader ? <>       
                    <div className='loader-div'>
                            <Spinner animation="border" className='spinner_color' color={'#097969'} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner><br />
                            <h3 className='loading_txt'>Loading ...</h3>
                        </div></> : ""
                }
                <Alert className="mt-4" key="success" variant="success" show={showAlert} onClose={() => setShowAlert(false)} dismissible>
                    Se guardó exitosamente la información.
                </Alert>

                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th className='encabezado_tabla'>#</th>
                            <th className='encabezado_tabla'>Nombre</th>
                            <th className='encabezado_tabla'>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            items && items.length > 0 && items.map((item, index) => {
                                return (
                                    <tr>
                                        <td className='data_tabla'>{index+1}</td>
                                        <td className='data_tabla'>{item.ExternalImageId}</td>
                                        <td className='data_tabla'><TiDelete className='icono_listado' onClick={() => handleShowDelete(item.FaceId, id)} /></td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>

            </Container>


            <Modal show={showDelete} onHide={handleCloseDelete}>
                <Modal.Header closeButton>
                <Modal.Title>Eliminar collection</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Está seguro que desea eliminar esta collection?</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseDelete}>
                    Cancelar
                </Button>
                <Button variant="danger" onClick={() => handleDelete()} >
                    Confirmar
                </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={showAdd} onHide={handleCloseAdd}>
                <Modal.Header closeButton>
                <Modal.Title>Agregar face</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        <Row className="justify-content-md-center mt-4">
                            <Col>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label htmlFor="input_nombre">Nombre de la persona</Form.Label>
                                        <Form.Control 
                                        id="input_nombre"
                                        type="text" 
                                        placeholder="Nombre de la persona"
                                        defaultValue={inputNombre}
                                        onKeyUp={(e) => setInputNombre(e.target.value)}
                                        required />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label htmlFor="input_foto">Foto</Form.Label>
                                        <Form.Control 
                                        id="input_foto"
                                        type="file" 
                                        placeholder="Foto"
                                        onChange={handleFileChange}
                                        required />
                                </Form.Group>
                                
                                
                                
                            </Col>
                        </Row>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseAdd}>
                    Cancelar
                </Button>
                {!guardando ? (
                    <Button variant="danger" type="submit" onClick={(handleSubmit)}>
                        Guardar
                    </Button>
                ) : (
                    <Button variant="danger" type="submit" disabled>
                        Guardando...
                    </Button>
                )}
                </Modal.Footer>
            </Modal>

        </>
  )
}

export default ListCollectionsFaces;